import React from 'react';
import Flatpickr from "react-flatpickr";

import "flatpickr/dist/themes/material_blue.css";

export default class DatePicker extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const options = {
      allowInput: false, // Only allow value to be changed by widget, not direct text input.
      altInput: true, // Show input field value in a more user friendly way.
      altFormat: "F j, Y h:i K", // Formatting example: May 19, 1998 11:00 AM
      dateFormat: "Z" // Inner-workings use ISO formatting.
    };

    return (
      // Ref: https://flatpickr.js.org/
      <Flatpickr
        value={this.props.value}
        options={options}
        onChange={value => this.props.handleDateTimeChange(this.props.name, value)}
        data-enable-time
      />
    );
  }
}
